import React from 'react'
import SearchForm, { SearchFormRef } from 'components/Search/SearchForm'
import { PROPERTY_TYPE_UNIQUE_STAYS } from 'constants/offer'
import { UNIQUE_STAYS_TYPEAHEAD_TYPES } from 'constants/search'
import GlobalSearchContextProvider from 'contexts/GlobalSearch/GlobalSearchContextProvider'
import { useGlobalVillasAndUniqueStaysSearchContext } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalVillasAndUniqueStaysSearch'
import { GLOBAL_SEARCH_INITIAL_STATE } from 'contexts/GlobalSearch/GlobalSearchState'
// import { useGlobalSearchRestoreFromStorage } from 'hooks/GlobalSearch/useGlobalSearchRestore'

interface Props {
  searchFormRef?: React.Ref<SearchFormRef>
}

function GlobalVillasAndUniqueStaysSearchTabContent(props: Props) {
  const { searchFormRef } = props
  // TODO: restoring these vals is yet to be confirmed with the Search product
  // const {
  //   restoredCheckinDate,
  //   restoredCheckoutDate,
  //   restoredOccupancies,
  //   restoredRecentSearchItems,
  // } = useGlobalSearchRestoreFromStorage()

  const { globalVillasAndUniqueStaysSearchDispatch, globalVillasAndUniqueStaysSearchState } = useGlobalVillasAndUniqueStaysSearchContext({
    ...GLOBAL_SEARCH_INITIAL_STATE,
    // checkinDate: restoredCheckinDate,
    // checkoutDate: restoredCheckoutDate,
    // occupancies: restoredOccupancies,
  })

  return <GlobalSearchContextProvider
    state={globalVillasAndUniqueStaysSearchState}
    dispatch={globalVillasAndUniqueStaysSearchDispatch}
  >
    <SearchForm
      submitOnApply
      saleUnit="Property"
      filters={{ propertyTypes: [PROPERTY_TYPE_UNIQUE_STAYS] }}
      // we want to search for all things except for le_property and bedbank_property
      // we only want to get the unique stay properties returned
      typeaheadTypes={UNIQUE_STAYS_TYPEAHEAD_TYPES}
      ref={searchFormRef}
    />
  </GlobalSearchContextProvider>
}

export default GlobalVillasAndUniqueStaysSearchTabContent
